import React from 'react';

function CameraPhoto(props: object) {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.0625 16.25H3.9375C3.5894 16.25 3.25556 16.1183 3.00942 15.8839C2.76328 15.6495 2.625 15.3315 2.625 15V6.25C2.625 5.91848 2.76328 5.60054 3.00942 5.36612C3.25556 5.1317 3.5894 5 3.9375 5H6.5625L7.875 3.125H13.125L14.4375 5H17.0625C17.4106 5 17.7444 5.1317 17.9906 5.36612C18.2367 5.60054 18.375 5.91848 18.375 6.25V15C18.375 15.3315 18.2367 15.6495 17.9906 15.8839C17.7444 16.1183 17.4106 16.25 17.0625 16.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 13.125C12.131 13.125 13.4531 11.8658 13.4531 10.3125C13.4531 8.7592 12.131 7.5 10.5 7.5C8.86903 7.5 7.54688 8.7592 7.54688 10.3125C7.54688 11.8658 8.86903 13.125 10.5 13.125Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CameraPhoto;
